import React from 'react';


const ArticleCardOnly = ({ details }) => {
    const requireImage = chemin => {
        if("" !== chemin){
            return chemin
        }else{
            return require(`../img/default.png`)
        }
    }
    return (
        <div>
            {
            <div className="articleList">
                <img 
                src={requireImage(details.base64)}
                alt={details.nom}
                />
            <div className="nom-article-list">
                <h1>{details.nom}</h1>
                <h3>{details.preambule}</h3>
                <p className="preligne">{details.texte}</p>
            </div>
            </div>
            }
        </div>
    );
};

export default ArticleCardOnly;